import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { amountFormat } from "../../../../services/common.service";
import { useDispatch, useSelector } from "react-redux";
import {
  profileDetailsSelector,
  selectedAccountSelector,
} from "../../../../store/selectors/app.selector";
import { setAccountList } from "../../../../store/actions/app.action";
import AccountService from "../../../../services/accounts.service";
import CommonOtp from "../../../../components/otp";
import handIcon from "../../../../assests/images/hand_icon.png";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import AccountCard from "../../../../components/account-card";
import AccountSelectedCard from "../../../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { AiOutlineInfoCircle } from "react-icons/ai";
import AccountClassComponent from "../../../../components/account-class-card";
import { CONFIG } from "../../../../environment";
import AccountClassCardComponent from "../../../../components/account-class-card";

export default function AddAccount() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [stage, setStage] = useState(1);
  const location = useLocation();
  const selectedAccount = useSelector(selectedAccountSelector);
  const [formDetails, setFormDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [respDetails, setRespDetails] = useState([]);
  const [accountClass, setAccountClass] = useState("");
  const [currency, setCurrency] = useState("");
  const [currencyList, setCurrencylist] = useState("");
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [completedDetails, setCompletedDetails] = useState({});
  const profileDetails = useSelector(profileDetailsSelector);
  const [allMessages, setAllMessages] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    getAccountClasses();
  }, []);

  const categorizeAccounts = (accounts) => {
    return accounts.reduce((acc, account) => {
      const { accountType } = account;
      if (!acc[accountType]) {
        acc[accountType] = [];
      }
      acc[accountType].push(account);
      return acc;
    }, {});
  };

  const getAccountClasses = useCallback(async (type) => {
    try {
      const response = await AccountService.getAccountClasses(type);
      if (response.status === 200) {
        const { similarAcctClassMsg, insufficientBalMsg, txnMsg } =
          response.data;
        const categorizedData = categorizeAccounts(
          response.data.accountClasses
        );
        setRespDetails(response.data);
        setDataSource(categorizedData);
        setAllMessages({
          similarAcctClassMsg,
          insufficientBalMsg,
          txnMsg,
        });
      }
    } catch (error) {}
  }, []);

  // const dataSourceArray = Array.from(dataSource['accountClasses'] || []);

  const onVerify = useCallback(() => {
    try {
      let classlist = respDetails["accountClasses"].find(
        (ele) => ele.accountClass === accountClass
      );
      setFormDetails({
        accClass: accountClass,
        acctClassDescription: classlist?.acctClassDescription,
        accountType: classlist?.accountType,
        srcAccount: selectedAccount?.accountNo,
        srcAccountName: selectedAccount?.accountName,
        srcBranch: selectedAccount?.branchId,
        accountDesc: classlist?.description,
        accountCcy: currency,
        currency: currency,
        minimumBalance: classlist?.minimumBalance,
        customerId: selectedAccount?.customerId,
      });
      setStage(2);
    } catch (error) {
      console.log(error);
    }
  }, [selectedAccount, accountClass, dataSource, respDetails, currency]);

  const onVerifyDetails = useCallback(async () => {
    try {
      const response = await AccountService.createCASAAccountVerify(
        formDetails
      );
      if (response.status === 200) {
        setStage(3);
      }
    } catch (error) {}
  }, [formDetails]);

  const onConfirm = useCallback(
    async (value) => {
      try {
        const response = await AccountService.createCASAAccountConfirm({
          // currency: selectedAccount?.accountCurrency,
          brnCode: selectedAccount?.branchId,
          ...value,
        });
        if (response.status === 200) {
          dispatch(setAccountList([]));
          setCompletedDetails(response.data);
          setSuccessVisible(true);
          await AccountService.getQuickAccounts("BA");
        }
      } catch (error) {
        setOtp("");
      }
    },
    [formDetails, selectedAccount]
  );

  const handleAccountClass = useCallback(
    async (value) => {
      setAccountClass(value);
      setCurrencylist(
        respDetails["accountClasses"].find((ele) => ele.accountClass === value)
          .currency
      );
      setShowModal(true);
    },
    [respDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();
      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
            handleResendOtp={() => onVerifyDetails(formDetails)}
            cancelTransaction={() => {
              navigate("/accounts");
            }}
          />
        );
      case 4:
        return renderSuccess();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <h5>
          {t("pages.my_accounts.common_my_accounts.choose_acc", {
            defaultValue: "Choose an account that fits your needs",
          })}
        </h5>
        <p>
          {t("pages.my_accounts.common_my_accounts.tailor_desc", {
            defaultValue:
              "We have tailor-made financial products and services just for you.",
          })}
        </p>
        <AccountClassCardComponent
          dataSource={dataSource}
          allMessages={allMessages}
          selected={accountClass}
          onChange={(value) => handleAccountClass(value.target.value)}
        />

        <div className="d-flex justify-content-end  mt-3">
          <Button
            onClick={() => navigate("/accounts", { state: location.state })}
            type="default"
            size="large"
            className="secondary-btn"
            style={{ marginRight: 20 }}
          >
            {t("buttons.cancel_btn", {
              defaultValue: "Cancel",
            })}
          </Button>
          <Button
            type="primary"
            size="large"
            className="primary-btn"
            htmlType="submit"
            onClick={onVerify}
            disabled={!currency}
          >
            {t("buttons.next_btn", {
              defaultValue: "Next",
            })}
          </Button>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <div className="card-padding">
        <h5>
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>
        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("common.please_check", {
            defaultValue:
              "Please check the details carefully, before you proceed",
          })}
        </p>

        <div className="mt-3 confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_class", {
                  defaultValue: "Account Class",
                })}
              </label>
              <span>{formDetails?.acctClassDescription}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("common.account_class_desc", {
                  defaultValue: "Account Class Description",
                })}
              </label>
              <span>{formDetails?.accountDesc}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.service_request.common_service.account_type", {
                  defaultValue: "Account Type",
                })}
              </label>
              <span>
                {formDetails?.accountType === "SA"
                  ? "Saving Account"
                  : formDetails?.accountType}
              </span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.my_accounts.casa.transaction_currency", {
                  defaultValue: "Transaction currency",
                })}
              </label>
              <span>{formDetails?.accountCcy}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-5">
          <Button
            size="large"
            onClick={() => setStage(1)}
            className="secondary-btn"
            type="default"
            style={{ marginRight: 30 }}
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>

          <Button size="large" onClick={() => onVerifyDetails()} type="primary">
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </div>
    );
  }

  function renderSuccess() {
    return (
      <div align="center" className="mt-3">
        <img alt="success" src={handIcon} height={100} />
        <p className="mt-3 mb-3">
          {t("pages.my_accounts.casa.acc_create_sucess_txt", {
            defaultValue:
              "Account Creation Request has been submitted successfully.",
          })}
        </p>

        <Button
          type="primary"
          size="large"
          onClick={() => {
            navigate("/accounts", { state: "BA" });
          }}
        >
          {t("buttons.done_btn", { defaultValue: "Done" })}
        </Button>
      </div>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.common_my_accounts.add_acc", {
                defaultValue: "Open Account",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.common_my_accounts.add_acc", {
                defaultValue: "Open Account",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" >
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" >
              <AccountSelectedCard />
            </Card>
          </div>
        )}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className=" application-card">{renderSwitch()}</Card>
        </div>
      </div>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{completedDetails.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/accounts");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        closable={true}
        maskClosable={false}
        open={showModal}
        footer={null}
        width={450}
        mask={true}
        onCancel={() => {
          setShowModal(false);
        }}
        centered
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.my_accounts.casa.currency_selection", {
              defaultValue: "Currency Selection",
            })}
          </h6>
          <div className=" d-block">
            <Select
              onChange={setCurrency}
              className="account-class-select"
              optionFilterProp="children"
              style={{ width: "200px" }}
              placeholder={t("pages.my_accounts.casa.select_currency", {
                defaultValue: "Select Currency",
              })}
            >
              {currencyList.split(",").map((option, index) => (
                <Select.Option key={index} value={option}>
                  {option}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="mt-4 mb-3" align="center">
            <Button
              type="primary"
              className="primary-btn"
              style={{ width: 120 }}
              size="large"
              disabled={!currency}
              onClick={() => {
                setShowModal(false);
              }}
            >
              {t("buttons.next_btn", {
                defaultValue: "Next",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
